import { render, staticRenderFns } from "./Estadisticas2019.vue?vue&type=template&id=b990c094&scoped=true"
import script from "./Estadisticas2019.vue?vue&type=script&lang=js"
export * from "./Estadisticas2019.vue?vue&type=script&lang=js"
import style0 from "./Estadisticas2019.vue?vue&type=style&index=0&id=b990c094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b990c094",
  null
  
)

export default component.exports